// src/dev/scenarios.ts
export interface DevScenario {
  id: string;
  label: string;
  group: string;
}

export const SCENARIOS: DevScenario[] = [
  // Geral
  { id: 'cenario-geral-capa', label: '🏠 Capa Geral', group: 'Geral' },
  { id: 'cenario-geral-modulo01', label: '📘 Geral – Módulo 01', group: 'Geral' },

  // Gestores
  { id: 'cenario-gestores-modulo02', label: '👔 Gestores – Módulo 02', group: 'Gestores' },
  { id: 'cenario-gestores-modulo03', label: '👔 Gestores – Módulo 03', group: 'Gestores' },
  { id: 'cenario-gestores-modulo04', label: '👔 Gestores – Módulo 04', group: 'Gestores' },

  // Profissionais
  {
    id: 'cenario-profissionais-modulo02',
    label: '🧑‍⚕️ Profissionais – Módulo 02',
    group: 'Profissionais',
  },
  {
    id: 'cenario-profissionais-modulo03',
    label: '🧑‍⚕️ Profissionais – Módulo 03',
    group: 'Profissionais',
  },
  {
    id: 'cenario-profissionais-modulo04',
    label: '🧑‍⚕️ Profissionais – Módulo 04',
    group: 'Profissionais',
  },

  // Extras
  { id: 'cenario-televisao', label: '📺 Televisão / Modal', group: 'Extras' },
];
